import styled from "styled-components";

export const FiltersContainerLeftContainer = styled.div`  
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const FiltersContainerRightContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  gap: 10px;

  & div[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const FilterBarContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 90px;
`;



export const FilterBarLeftContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const FilterBarRightContent = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  align-items: center;
  width: 150px;
  height: 100%;
  padding-inline-start: 30px;
`;
